/**
 * Generate PDF using simple text approach (no HTML)
 * @param {Object} data - Invoice data
 */
export function printProformaInvoice(data) {
  const {
    sku = '',
    productName = '',
    price = 0,
    currency = '',
    customerName = '',
    customerSurname = '',
    customerEmail = '',
    customerPhone = '',
    cuiNumber = '',
    city = '',
    street = '',
    postCode = '',
    addressFree = '',
    workOrderId = '',
    vatRate = 0,
    quantity = 1, // added
    productOrderId = null
  } = data;

  const priceNum = parseFloat(price) || 0;
  const qtyNum = parseInt(quantity, 10) || 0;
  const vatPercent = parseFloat(vatRate) || 0;
  const factor = (vatPercent + 100) / 100;                // (vatRate + 100) / 100
  const priceWithoutVat = factor !== 0 ? priceNum / factor : 0;
  const value = priceWithoutVat * qtyNum;                 // Value = PriceWithoutVat * Quantity
  const vatValue = value * (vatPercent / 100);            // Vat Value = Value * (vatRate / 100)
  const total = value + vatValue;                         // Total = Value + Vat Value

  const fmt = (n) => n.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const htmlContent = `
<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Proforma Invoice</title>
<style>
  @page { margin: 0; size: A4; }
  html,body { width:210mm; height:297mm; }
  body { font-family: Arial, sans-serif; padding: 18mm 14mm 14mm 14mm; margin:0; font-size:11px; line-height:1.35; -webkit-print-color-adjust: exact; }
  .company-info { font-size:9px; line-height:1.3; margin:0 0 14px 2px; }
  .company-info strong { font-size:10px; }
  h1 { font-size:19px; margin:6px 0 0px; color:#1976d2; font-weight:700; }
  .header { text-align:center; margin-bottom:10px; }
  .section-title { background:#f0f0f0; padding:4px 8px; font-weight:600; font-size:11px; margin:10px 0 6px; border-left:4px solid #1976d2; }
  table { width:100%; border-collapse:collapse; }
  th, td { border:1px solid #ddd; padding:4px 6px; font-size:10px; vertical-align:top; }
  th { background:#1976d2; color:#fff; font-weight:600; }
  .info-table th { width:30%; }
  .info-table td { width:70%; }
  .footer { text-align:center; font-size:9px; color:#777; margin-top:12px; }
  * { page-break-inside: avoid; }
</style>
</head>
<body>
  <div class="company-info">
    <strong>VANZATOR: BEKO ROMANIA S.A.</strong><br>
    Capital social: 48.039.066,60 RON<br>
    Nr.ord.reg.com./an: J15/253/1991 <br>
    C.I.F.: RO933930<br>
    Sediul: str. 13 Decembrie, nr.210, Gaesti, jud. Dambovita<br>
    Banca: CITIBANK EUROPE plc.Dublin Romania Branch Bucuresti<br>
    Contul: RO76CITI0000000824771006<br>
    Telefon: 0245-605.111
  </div>
  <div class="header">
    <h1>PROFORMA INVOICE</h1>
    <div style="font-size:10px;">Date: ${new Date().toLocaleDateString()} | Product Order: ${productOrderId ?? 'N/A'}</div>
  </div>

  <div class="section-title">Product Information</div>
  <table class="info-table">
    <tr><th>SKU</th><td>${sku || '—'}</td></tr>
    <tr><th>Product</th><td>${productName || '—'}</td></tr>
    <tr><th>Price</th><td>${fmt(priceNum)} ${currency || ''}</td></tr>
    <tr><th>Quantity</th><td>${qtyNum}</td></tr>
    <tr><th>VAT Rate</th><td>%${vatPercent}</td></tr>
    <tr><th>Price Without VAT</th><td>${fmt(priceWithoutVat)} ${currency || ''}</td></tr>
    <tr><th>Value</th><td>${fmt(value)} ${currency || ''}</td></tr>
    <tr><th>VAT Value</th><td>${fmt(vatValue)} ${currency || ''}</td></tr>
    <tr><th>Total</th><td>${fmt(total)} ${currency || ''}</td></tr>
  </table>

  <div class="section-title">Customer Information</div>
  <table class="info-table">
    <tr><th>Name</th><td>${(customerName||'') + ' ' + (customerSurname||'')}</td></tr>
    <tr><th>CUI Number</th><td>${cuiNumber || '—'}</td></tr>
    <tr><th>Email</th><td>${customerEmail || '—'}</td></tr>
    <tr><th>Phone</th><td>${customerPhone || '—'}</td></tr>
    <tr><th>City</th><td>${city || '—'}</td></tr>
    <tr><th>Street</th><td>${street || '—'}</td></tr>
    <tr><th>Post Code</th><td>${postCode || '—'}</td></tr>
    <tr><th>Address</th><td>${addressFree || '—'}</td></tr>
  </table>

  <div class="footer">
    Vă rugăm să menționați pe ordinul de plată: numărul proformei și numele cumpărătorului înscris în proformă.<br>
    proformei și numele cumpărătorului înscris în proformă.
  </div>

  <script>
    (function(){
      var h=document.body.scrollHeight;
      var max=1120;
      if(h>max){
        var scale=max/h;
        document.body.style.transform='scale('+scale+')';
        document.body.style.transformOrigin='top left';
        document.body.style.width=(100/scale)+'%';
      }
    })();
  </script>
</body>
</html>
  `;

  const iframe = document.createElement('iframe');
  iframe.style.position = 'absolute';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = 'none';
  document.body.appendChild(iframe);
  const doc = iframe.contentWindow.document;
  doc.open();
  doc.write(htmlContent);
  doc.close();
  iframe.contentWindow.focus();
  setTimeout(() => {
    iframe.contentWindow.print();
    setTimeout(() => { document.body.removeChild(iframe); }, 400);
  }, 250);
}
